import { InstrumentStore } from '@eih-netbroker/common';
import { store } from '../state/store';

export const instrumentStore = new InstrumentStore(store);
